import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  addEmployee,
  getEmployees,
  getEmployee,
  editEmployee,
  deleteEmployee,
  getAllEmployees,
} from '../../store/actions/employee_action';
import _debounce from 'lodash/debounce';

// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllEmployees = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.employee);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);

  const allQuery = useCallback(
    _debounce(() => {
      dispatch(
        getEmployees({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteEmployee(deleteEntry));
    }
    allQuery();
  }, [deleteEntry]);

  useEffect(() => {
    if (pageNumber) {
      dispatch(
        getEmployees({
          pageNumber,
        })
      );
    }
  }, [pageNumber]);

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [data, setPageNumber, deleteBtnClicked];
};

// Get Single Data
export const useSingleEmployee = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.employee);
  useEffect(() => {
    dispatch(getEmployee(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateEmployee = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.employee);
  const addData = async (data) => {
    await dispatch(addEmployee(data));
  };
  return [data, addData];
};
export const useUpdateEmployee = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.employee);
  const updateData = async (id, data) => {
    await dispatch(editEmployee(id, data));
  };
  return [updateData];
};

export const useSelectAllEmployee = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState('');
  const [value, setValue] = useState('');
  const data = useSelector((state) => state.employee);
  useEffect(() => {
    dispatch(getAllEmployees({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  const [employee, setClientSearchField, setClientSearchValue] =
    useSelectAllEmployee();

  const [dropdownOptions, setDropdownOptions] = useState({});
  useEffect(() => {
    if (employee && employee.all_employees) {
      const newData = employee.all_employees.map((item) => {
        return { label: item.name, value: item._id };
      });
      setDropdownOptions({ ...dropdownOptions, reporting_manager: newData });
    }
  }, [employee]);

  return [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ];
};
